module.exports = __webpack_public_path__ + "media/images/background-error-19e767c8e2c49df9533d1b489964ff63.jpg";